import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const getHours = async params => (await request.getInstance()).get(API_ROUTES.statistics.getHours + params);
export const stat = async params => (await request.getInstance()).get(API_ROUTES.statistics.getStats + params);
export const getAnomalies = async params => (await request.getInstance()).get(API_ROUTES.statistics.getAnomalies + params);
export const fixAnomaly = async (id, data) => (await request.getInstance()).post(API_ROUTES.statistics.fixAnomaly.replace(':id', id), data);
